module.exports = __webpack_public_path__ + "static/media/control.e00837a1.jpg";